import React, { useEffect, useState, useContext } from "react";
import "../Biling.css";
import Header from "./Header";
import { useNavigate, useLocation } from "react-router-dom";
import { getAllInvoices, getSingleInvoice, getCurrentPlan } from "../services/pricingService";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { generateInvoicePDF } from "../utils/generateInvoicePDF";
import { AuthContext } from "../Hook/AuthProvider";
import { getProfile } from "../services/authenticationServices";
import Skeleton from "react-loading-skeleton";
import { SOCIAL_PROOF_COUNT, SOCIAL_PROOF_ASPIRANTS_GROWING_TEXT } from "../constants/socialProof";


function Biling() {
  const location = useLocation();
  const [activeItem, setActiveItem] = useState(
    location.state?.activeItem || "Biling"
  );



  const navigate = useNavigate();
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loader, setloader] = useState(false)
  const [popupOpen, setPopupOpen] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [planDetails, setPlanDetails] = useState(null);

  const isPro = profileData?.user_type === "pro";
  const validityDate = planDetails?.subscription_end_at
    ? new Date(planDetails.subscription_end_at).toLocaleDateString("en-GB")
    : profileData?.subscription_expires_at
      ? new Date(profileData.subscription_expires_at).toLocaleDateString("en-GB")
      : "";


  useEffect(() => {
    setloader(true)
    const fetchProfileData = async () => {
      try {
        const response = await getProfile();
        setProfileData(response)

      } catch (error) {
        console.error("Error fetching profile:", error);
      }
      finally {
        setloader(false);
      }
    };

    fetchProfileData();
  }, []);
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setPopupOpen(false);
    };
    if (popupOpen) window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [popupOpen]);

  const openPopup = () => setPopupOpen(true);
  const closePopup = () => setPopupOpen(false);

  useEffect(() => {
    fetchInvoices();
  }, []);
  const fetchInvoices = async () => {
    setLoading(true);
    try {
      const res = await getAllInvoices();
      setInvoices(res);

    } catch (err) {
      console.error("Failed to fetch invoices:", err);
    } finally {
      setLoading(false);

    }
  };

  useEffect(() => {
    const fetchCurrentPlan = async () => {
      try {
        const plan = await getCurrentPlan();
        setPlanDetails(plan);
      } catch (err) {
        console.error("Error fetching current plan:", err.message);
      }
    };

    fetchCurrentPlan();
  }, []);


  const downloadInvoice = async (invoiceId) => {
    try {
      const res = await getSingleInvoice(invoiceId);

      // Create a PDF preview (simple)
      const doc = new jsPDF();
      const content = `
        Invoice ID: ${res.invoice.invoice_id}
        User: ${res.user.first_name} ${res.user.last_name}
        Email: ${res.user.email}
        Amount: ₹${res.invoice.amount}
        Payment ID: ${res.payment.razorpay_payment_id}
        Date: ${new Date(res.invoice.created_at).toLocaleDateString()}
      `;

      doc.text(content, 10, 10);
      doc.save(`Invoice_${res.invoice.invoice_id}.pdf`);
      const invoiceData = await getSingleInvoice(invoiceId);
      generateInvoicePDF(invoiceData);
    } catch (err) {
      console.error("Failed to generate invoice:", err);
    }
  };

  useEffect(() => {
    fetchInvoices();
  }, []);

  return (
    <>
      <div style={{ width: "100%" }}>
        <div className="header-biling">
          <Header
            message={[{ message: `Settings/Billing` }]}
            flag={false}
          />
        </div>
        <div className="plandiv-biling">
              {!loader ? (
                <div className="billing-plans-container">
                  {/* Free Plan Card */}
                  <div className={`billing-plan-card free-plan-card ${!isPro ? "is-active" : ""}`}>
                    <div className="plan-card-header">
                      <div className="plan-card-title-group">
                        <span className="text-planner-free">Free</span>
                        <span className="plan-card-subtitle">Basic preparation access</span>
                      </div>
                      {!isPro && (
                        <div className="plan-active-chip">
                          <span className="plan-active-dot"></span> Active Plan
                        </div>
                      )}
                    </div>

                    <div className="icon-rule-gap-main-div plan-card-features">
                      <div className="icon-rule-gap">
                        <img src="/assets/images/right-sign.svg" alt="star" />
                        <span className="header-dev-conatin-rightside-spantext">
                          5 queries / day
                        </span>
                      </div>
                      <div className="icon-rule-gap">
                        <img src="/assets/images/right-sign.svg" alt="star" />
                        <span className="header-dev-conatin-rightside-spantext">
                          Limited evaluations / month
                        </span>
                      </div>
                      <div className="icon-rule-gap">
                        <img src="/assets/images/right-sign.svg" alt="star" />
                        <span className="header-dev-conatin-rightside-spantext">
                          Limited Study mode
                        </span>
                      </div>
                      <div className="icon-rule-gap">
                        <img src="/assets/images/right-sign.svg" alt="star" />
                        <span className="header-dev-conatin-rightside-spantext">
                          Limited Tests
                        </span>
                      </div>
                      <div className="icon-rule-gap">
                        <img src="/assets/images/right-sign.svg" alt="star" />
                        <span className="header-dev-conatin-rightside-spantext">
                          Up to 500 MB My Notes storage
                        </span>
                      </div>
                    </div>

                    <div className="plan-card-footer">
                      {!isPro ? (
                        <div className="plan-active-status-bar">
                          <span className="plan-active-pill">
                            <span className="plan-active-dot"></span> Active Plan
                          </span>
                        </div>
                      ) : (
                        <div className="plan-card-inactive-note">
                          <span>Standard tier included</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Yooki Pro Card */}
                  <div className={`billing-plan-card pro-plan-card ${isPro ? "is-active" : ""}`}>
                    <div className="plan-card-header">
                      <div className="plan-card-title-group">
                        <div className="text-planner-free pro-title-row">
                          <span>Yooki</span>{" "}
                          <img
                            src="/assets/images/yooki-pro-tag-billing.svg"
                            alt="Pro"
                            className="billing-pro-badge-img"
                          />
                        </div>
                        <span className="plan-card-subtitle">Full preparation & analytics suite</span>
                      </div>

                      <div className="plan-card-header-badges">
                        <div className="text-most-popular">
                          <img
                            src="/assets/images/sparkling-fill.svg"
                            alt=""
                            height={12}
                            width={12}
                          />
                          Most Popular
                        </div>
                        {isPro && (
                          <div className="plan-active-chip pro-active-chip">
                            <span className="plan-active-dot"></span> Active Plan
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="icon-rule-gap-main-div plan-card-features">
                      <div className="icon-rule-gap">
                        <img
                          src="/assets/images/right-sign-color.svg"
                          alt="star"
                        />
                        <span className="header-dev-conatin-rightside-spantext">
                          Unlimited Queries
                        </span>
                      </div>
                      <div className="icon-rule-gap">
                        <img
                          src="/assets/images/right-sign-color.svg"
                          alt="star"
                        />
                        <span className="header-dev-conatin-rightside-spantext">
                          Unlimited evaluations
                        </span>
                      </div>
                      <div className="icon-rule-gap">
                        <img
                          src="/assets/images/right-sign-color.svg"
                          alt="star"
                        />
                        <span className="header-dev-conatin-rightside-spantext">
                          Full access to Study mode
                        </span>
                      </div>
                      <div className="icon-rule-gap">
                        <img
                          src="/assets/images/right-sign-color.svg"
                          alt="star"
                        />
                        <span className="header-dev-conatin-rightside-spantext">
                          Unlimited Test access
                        </span>
                      </div>
                      <div className="icon-rule-gap">
                        <img
                          src="/assets/images/right-sign-color.svg"
                          alt="star"
                        />
                        <span className="header-dev-conatin-rightside-spantext">
                          Up to 2 GB My Notes storage
                        </span>
                      </div>
                    </div>

                    <div className="plan-card-footer">
                      {isPro ? (
                        <div className="pro-active-actions-row">
                          {validityDate ? (
                            <div className="plan-validity-pill">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0284c7" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                                <line x1="16" y1="2" x2="16" y2="6"></line>
                                <line x1="8" y1="2" x2="8" y2="6"></line>
                                <line x1="3" y1="10" x2="21" y2="10"></line>
                              </svg>
                              <span>Valid till <strong>{validityDate}</strong></span>
                            </div>
                          ) : (
                            <div></div>
                          )}
                          <button
                            className="plan-extend-pro-btn"
                            onClick={() => navigate("/Price")}
                          >
                            Extend Pro
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                              <line x1="5" y1="12" x2="19" y2="12"></line>
                              <polyline points="12 5 19 12 12 19"></polyline>
                            </svg>
                          </button>
                        </div>
                      ) : (
                        <div className="pro-upgrade-actions-column">
                          <div className="price-tag-bilings-price-tag-offer">
                            Save 65% with the yearly plan
                          </div>
                          <button
                            className="button-billing col-of-upgrad plan-upgrade-pro-btn"
                            onClick={() => navigate("/Price")}
                          >
                            <img
                              src="/assets/images/sparkling-fill-gradient.svg"
                              alt=""
                            />
                            Upgrade to Pro
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <Skeleton variant="rounded" width={896} height={240} />
              )}
              {/* <div className="upgared-div">
            <div>
              <div>Upgrade to Pro to get unlimited access.</div>
              <div>
                Continue your preparation with Unlimited Access to all features
                of Yooki.
              </div>
            </div>
            <div className="upgradebutton" onClick={() => { navigate("/Price") }}>
              {" "}
              <img src="assets/images/upgrade-popup.svg" alt="star" />

              <span className="upgradebutton-text">Upgrade Now</span>
            </div>
          </div> */}
              {/* <div className="card-conatiner-add">
            <div className="button-add-card-left">
              <div className="button-add-card-left-text-h">Payment Information</div>
              <div className="button-add-card-left-text-p">Quick, safe, and encrypted — add your payment method to get started</div>
            </div>
            <div className="button-add-card">
              <span className="button-add-card-text">Add Card</span>
            </div>
          </div> */}
              <div className="bottom-div-biling">
                <div className="invoice-history-text">
                  <span className="invoice-history-text-p">
                    {" "}
                    Transaction History
                  </span>
                </div>

                {loading ? (
                  <div className="uploadbux">Loading transactions...</div>
                ) : invoices.length === 0 ? (
                  <div className="uploadbux">
                    <span className="uploadbox-text">No active subscription yet.</span>
                  </div>
                ) : (
                  <div className="invoice-table">
                    <table className="invoice-table-table">
                      <thead className="invoice-table-thead">
                        <tr>
                          <th>Plan Name</th>
                          <th>Date</th>
                          <th>Amount</th>
                          <th>Invoice ID</th>
                          {/* <th>Invoice</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {invoices?.slice().map((inv) => (
                          <tr key={inv.invoice_id} className="invoice-table-row">
                            <td className="invoice-table-plan">{inv.description || "—"}</td>
                            <td className="invoice-table-date">
                              {inv.date
                                ? new Date(inv.date).toLocaleDateString("en-US", {
                                  month: "short",
                                  day: "2-digit",
                                  year: "numeric",
                                })
                                : "--"}
                            </td>
                            <td className="invoice-table-amount">₹{inv.payment_amount}</td>
                            <td className="invoice-table-id">{inv.invoice_id}</td>
                            {/* <td className="invoice-table-action">
                              <button
                                className="invoice-table-downloadBtn"
                                onClick={() => downloadInvoice(inv.invoice_id)}
                                disabled // 🔹 disables the button
                                title="Work in progress"
                              >
                                Download Invoice <span className="invoice-table-downloadIcon"><svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M14.8857 9.78906V13.7891C14.8857 13.9217 14.8331 14.0488 14.7393 14.1426C14.6455 14.2364 14.5184 14.2891 14.3857 14.2891H3.38574C3.25313 14.2891 3.12596 14.2364 3.03219 14.1426C2.93842 14.0488 2.88574 13.9217 2.88574 13.7891V9.78906C2.88574 9.65645 2.93842 9.52928 3.03219 9.43551C3.12596 9.34174 3.25313 9.28906 3.38574 9.28906C3.51835 9.28906 3.64553 9.34174 3.7393 9.43551C3.83306 9.52928 3.88574 9.65645 3.88574 9.78906V13.2891H13.8857V9.78906C13.8857 9.65645 13.9384 9.52928 14.0322 9.43551C14.126 9.34174 14.2531 9.28906 14.3857 9.28906C14.5184 9.28906 14.6455 9.34174 14.7393 9.43551C14.8331 9.52928 14.8857 9.65645 14.8857 9.78906ZM8.53199 10.1428C8.57843 10.1893 8.63357 10.2262 8.69427 10.2513C8.75497 10.2765 8.82003 10.2895 8.88574 10.2895C8.95145 10.2895 9.01651 10.2765 9.07721 10.2513C9.13791 10.2262 9.19306 10.1893 9.23949 10.1428L11.7395 7.64281C11.8095 7.57289 11.8572 7.48376 11.8765 7.38672C11.8958 7.28967 11.8859 7.18908 11.8481 7.09767C11.8102 7.00626 11.746 6.92814 11.6637 6.8732C11.5814 6.81827 11.4847 6.78898 11.3857 6.78906H9.38574V2.78906C9.38574 2.65645 9.33306 2.52928 9.2393 2.43551C9.14553 2.34174 9.01835 2.28906 8.88574 2.28906C8.75313 2.28906 8.62596 2.34174 8.53219 2.43551C8.43842 2.52928 8.38574 2.65645 8.38574 2.78906V6.78906H6.38574C6.28679 6.78898 6.19005 6.81827 6.10775 6.8732C6.02545 6.92814 5.96131 7.00626 5.92343 7.09767C5.88555 7.18908 5.87565 7.28967 5.89498 7.38672C5.9143 7.48376 5.96199 7.57289 6.03199 7.64281L8.53199 10.1428Z" fill="#37A7D5" />
                                  </svg>
                                </span>
                              </button>
                            </td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </div>
      {/* billing-popup overlay (outside blurred content) */}
      <div
        className={`billing-popup-overlay ${popupOpen ? "b-active" : ""}`}
        aria-hidden={!popupOpen}
        onClick={(e) => {
          if (e.target === e.currentTarget) closePopup();
        }}
      >
        <div
          className="billing-popup-popup"
          role="dialog"
          aria-modal="true"
          aria-labelledby="billingPopupTitle"
        >
          <div className="billing-popup-wrapper">
            <div className="billing-popup-modal">
              <div className="billing-popup-left">
                <div className="billing-popup-image-wrap">
                  <img
                    src="/assets/images/img-side-popup.webp"
                    alt="Yooki Pro"
                    className="billing-popup-image"
                  />
                  <div className="billing-popup-aspirants-bar">
                    <div className="billing-popup-avatars">
                      <img src="https://framerusercontent.com/images/95N6RToKz4zOmwlzgkULlRjmago.png?width=64" alt="" className="billing-popup-avatar" />
                      <img src="https://framerusercontent.com/images/ctl1UpVuhVW7eH05x0lfOOclTH4.png?width=64" alt="" className="billing-popup-avatar" />
                      <img src="https://framerusercontent.com/images/iZBMyLoUBMLihAUBbHiXVC1jJY.png?width=64" alt="" className="billing-popup-avatar" />
                      <img src="https://framerusercontent.com/images/MPeZPUhr2ZwfPhXK7vB6zwlzY.png?width=64" alt="" className="billing-popup-avatar" />
                      <img src="https://framerusercontent.com/images/r06bkAsScOTqa7NA6ciWVKDBSfY.png?width=64" alt="" className="billing-popup-avatar" />
                    </div>
                    <span className="billing-popup-count">{SOCIAL_PROOF_COUNT}</span>
                  </div>
                  <div className="billing-popup-aspirants-desc">
                    {SOCIAL_PROOF_ASPIRANTS_GROWING_TEXT}
                  </div>
                </div>
              </div>
              <div className="billing-popup-right">
                <button
                  className="billing-popup-close"
                  onClick={closePopup}
                  aria-label="Close popup"
                >
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.79102 4.90625L13.6931 12.9748"
                      stroke="#49546C"
                      strokeWidth="1.16667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M13.6914 4.90625L4.78936 12.9748"
                      stroke="#49546C"
                      strokeWidth="1.16667"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
                <div className="billing-popup-title-row">
                  <span className="billing-popup-emoji">🎉</span>
                  <h2 className="billing-popup-title">Welcome to Yooki</h2>
                  <span className="billing-popup-pro">
                    <svg
                      width="57"
                      height="28"
                      viewBox="0 0 57 28"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <rect
                        x="0.726562"
                        y="1"
                        width="55"
                        height="26"
                        rx="7.5"
                        fill="url(#paint0_linear_3970_53750)"
                      />
                      <rect
                        x="0.726562"
                        y="1"
                        width="55"
                        height="26"
                        rx="7.5"
                        stroke="url(#paint1_linear_3970_53750)"
                      />
                      <path
                        d="M18.1845 14.3041L15.0725 13.1541L13.9261 10.0396C13.8582 9.85522 13.7354 9.69605 13.5742 9.58362C13.413 9.4712 13.2212 9.41092 13.0247 9.41092C12.8282 9.41092 12.6364 9.4712 12.4752 9.58362C12.314 9.69605 12.1912 9.85522 12.1233 10.0396L10.9697 13.1541L7.85528 14.3004C7.67086 14.3683 7.5117 14.4912 7.39927 14.6523C7.28684 14.8135 7.22656 15.0053 7.22656 15.2018C7.22656 15.3984 7.28684 15.5902 7.39927 15.7513C7.5117 15.9125 7.67086 16.0353 7.85528 16.1032L10.9697 17.2568L12.1161 20.3713C12.184 20.5557 12.3068 20.7149 12.468 20.8273C12.6292 20.9397 12.821 21 13.0175 21C13.214 21 13.4058 20.9397 13.567 20.8273C13.7282 20.7149 13.851 20.5557 13.9189 20.3713L15.0725 17.2568L18.1869 16.1105C18.3713 16.0426 18.5305 15.9198 18.6429 15.7586C18.7554 15.5974 18.8156 15.4056 18.8156 15.2091C18.8156 15.0126 18.7554 14.8208 18.6429 14.6596C18.5305 14.4984 18.3713 14.3756 18.1869 14.3077L18.1845 14.3041ZM14.9518 8.9307C14.9518 8.80268 15.0027 8.67991 15.0932 8.58939C15.1837 8.49888 15.3065 8.44802 15.4345 8.44802H16.3998V7.48267C16.3998 7.35466 16.4507 7.23189 16.5412 7.14137C16.6317 7.05085 16.7545 7 16.8825 7C17.0105 7 17.1333 7.05085 17.2238 7.14137C17.3143 7.23189 17.3652 7.35466 17.3652 7.48267V8.44802H18.3305C18.4585 8.44802 18.5813 8.49888 18.6718 8.58939C18.7623 8.67991 18.8132 8.80268 18.8132 8.9307C18.8132 9.05871 18.7623 9.18148 18.6718 9.272C18.5813 9.36252 18.4585 9.41337 18.3305 9.41337H17.3652V10.3787C17.3652 10.5067 17.3143 10.6295 17.2238 10.72C17.1333 10.8105 17.0105 10.8614 16.8825 10.8614C16.7545 10.8614 16.6317 10.8105 16.5412 10.72C16.4507 10.6295 16.3998 10.5067 16.3998 10.3787V9.41337H15.4345C15.3065 9.41337 15.1837 9.36252 15.0932 9.272C15.0027 9.18148 14.9518 9.05871 14.9518 8.9307ZM21.2266 11.8267C21.2266 11.9548 21.1757 12.0775 21.0852 12.168C20.9947 12.2586 20.8719 12.3094 20.7439 12.3094H20.2612V12.7921C20.2612 12.9201 20.2104 13.0429 20.1198 13.1334C20.0293 13.2239 19.9066 13.2748 19.7785 13.2748C19.6505 13.2748 19.5278 13.2239 19.4372 13.1334C19.3467 13.0429 19.2959 12.9201 19.2959 12.7921V12.3094H18.8132C18.6852 12.3094 18.5624 12.2586 18.4719 12.168C18.3814 12.0775 18.3305 11.9548 18.3305 11.8267C18.3305 11.6987 18.3814 11.576 18.4719 11.4854C18.5624 11.3949 18.6852 11.3441 18.8132 11.3441H19.2959V10.8614C19.2959 10.7334 19.3467 10.6106 19.4372 10.5201C19.5278 10.4296 19.6505 10.3787 19.7785 10.3787C19.9066 10.3787 20.0293 10.4296 20.1198 10.5201C20.2104 10.6106 20.2612 10.7334 20.2612 10.8614V11.3441H20.7439C20.8719 11.3441 20.9947 11.3949 21.0852 11.4854C21.1757 11.576 21.2266 11.6987 21.2266 11.8267Z"
                        fill="url(#paint2_linear_3970_53750)"
                      />
                      <path
                        d="M26.5546 18.5V8.036H29.8506C30.6292 8.036 31.3226 8.13733 31.9306 8.34C32.5386 8.54267 33.0186 8.87867 33.3706 9.348C33.7226 9.81733 33.8986 10.4573 33.8986 11.268C33.8986 12.036 33.7226 12.6707 33.3706 13.172C33.0292 13.6733 32.5546 14.0467 31.9466 14.292C31.3492 14.5373 30.6719 14.66 29.9146 14.66H28.4106V18.5H26.5546ZM28.4106 13.172H29.7706C30.5492 13.172 31.1252 13.012 31.4986 12.692C31.8826 12.372 32.0746 11.8973 32.0746 11.268C32.0746 10.6067 31.8719 10.1533 31.4666 9.908C31.0719 9.652 30.4852 9.524 29.7066 9.524H28.4106V13.172ZM35.7071 18.5V10.644H37.2271L37.3551 12.036H37.4191C37.6964 11.524 38.0271 11.1347 38.4111 10.868C38.8057 10.5907 39.2164 10.452 39.6431 10.452C39.8457 10.452 40.0164 10.4627 40.1551 10.484C40.2937 10.5053 40.4217 10.548 40.5391 10.612L40.1711 12.18C40.0431 12.148 39.9257 12.1267 39.8191 12.116C39.7124 12.0947 39.5737 12.084 39.4031 12.084C39.0937 12.084 38.7684 12.2067 38.4271 12.452C38.0857 12.6867 37.7924 13.1027 37.5471 13.7V18.5H35.7071ZM44.7356 18.692C44.0849 18.692 43.4769 18.532 42.9116 18.212C42.3462 17.8813 41.8876 17.412 41.5356 16.804C41.1836 16.1853 41.0076 15.444 41.0076 14.58C41.0076 13.7053 41.1836 12.964 41.5356 12.356C41.8876 11.7373 42.3462 11.268 42.9116 10.948C43.4769 10.6173 44.0849 10.452 44.7356 10.452C45.3969 10.452 46.0102 10.6173 46.5756 10.948C47.1409 11.268 47.5996 11.7373 47.9516 12.356C48.3036 12.964 48.4796 13.7053 48.4796 14.58C48.4796 15.444 48.3036 16.1853 47.9516 16.804C47.5996 17.412 47.1409 17.8813 46.5756 18.212C46.0102 18.532 45.3969 18.692 44.7356 18.692ZM44.7356 17.188C45.1196 17.188 45.4502 17.0813 45.7276 16.868C46.0049 16.6547 46.2182 16.3507 46.3676 15.956C46.5169 15.5613 46.5916 15.1027 46.5916 14.58C46.5916 14.0573 46.5169 13.5987 46.3676 13.204C46.2182 12.8093 46.0049 12.5053 45.7276 12.292C45.4502 12.068 45.1196 11.956 44.7356 11.956C44.3516 11.956 44.0209 12.068 43.7436 12.292C43.4769 12.5053 43.2689 12.8093 43.1196 13.204C42.9702 13.5987 42.8956 14.0573 42.8956 14.58C42.8956 15.1027 42.9702 15.5613 43.1196 15.956C43.2689 16.3507 43.4769 16.6547 43.7436 16.868C44.0209 17.0813 44.3516 17.188 44.7356 17.188Z"
                        fill="#2A2A2A"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_3970_53750"
                          x1="0.226562"
                          y1="14"
                          x2="66.9357"
                          y2="17.8778"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#E2F8FF" />
                          <stop offset="1" stopColor="#FFF2E0" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_3970_53750"
                          x1="11.3471"
                          y1="0.5"
                          x2="61.1672"
                          y2="11.6255"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#32B2DD" />
                          <stop offset="1" stopColor="#F99710" />
                        </linearGradient>
                        <linearGradient
                          id="paint2_linear_3970_53750"
                          x1="11.1641"
                          y1="7"
                          x2="19.4766"
                          y2="21"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#32B2DD" />
                          <stop offset="1" stopColor="#F99710" />
                        </linearGradient>
                      </defs>
                    </svg>
                  </span>
                </div>
                <span className="billing-popup-tagline">
                  You’ve unlocked everything you need to prep smarter and
                  faster.
                </span>
                <div className="billing-popup-access-header">
                  You now have access to:
                </div>
                <ul className="billing-popup-access-list">
                  <li>
                    <span className="billing-popup-access-icon">
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M14.7499 11.1131L11.1933 9.79888L9.8832 6.2395C9.80561 6.02873 9.66525 5.84683 9.48103 5.71834C9.29682 5.58985 9.07763 5.52096 8.85303 5.52096C8.62844 5.52096 8.40925 5.58985 8.22503 5.71834C8.04082 5.84683 7.90045 6.02873 7.82287 6.2395L6.50448 9.79888L2.9451 11.109C2.73433 11.1866 2.55243 11.3269 2.42394 11.5112C2.29545 11.6954 2.22656 11.9146 2.22656 12.1392C2.22656 12.3638 2.29545 12.5829 2.42394 12.7672C2.55243 12.9514 2.73433 13.0917 2.9451 13.1693L6.50448 14.4877L7.81459 18.0471C7.89218 18.2579 8.03255 18.4398 8.21676 18.5682C8.40097 18.6967 8.62016 18.7656 8.84476 18.7656C9.06936 18.7656 9.28855 18.6967 9.47276 18.5682C9.65697 18.4398 9.79734 18.2579 9.87492 18.0471L11.1933 14.4877L14.7527 13.1776C14.9635 13.1 15.1454 12.9596 15.2738 12.7754C15.4023 12.5912 15.4712 12.372 15.4712 12.1474C15.4712 11.9228 15.4023 11.7036 15.2738 11.5194C15.1454 11.3352 14.9635 11.1948 14.7527 11.1173L14.7499 11.1131ZM11.0554 4.97214C11.0554 4.82583 11.1135 4.68553 11.217 4.58208C11.3204 4.47863 11.4607 4.42051 11.607 4.42051H12.7103V3.31725C12.7103 3.17095 12.7684 3.03064 12.8719 2.92719C12.9753 2.82374 13.1156 2.76562 13.2619 2.76562C13.4082 2.76563 13.5485 2.82374 13.652 2.92719C13.7554 3.03064 13.8135 3.17095 13.8135 3.31725V4.42051H14.9168C15.0631 4.42051 15.2034 4.47863 15.3069 4.58208C15.4103 4.68553 15.4684 4.82583 15.4684 4.97214C15.4684 5.11844 15.4103 5.25874 15.3069 5.36219C15.2034 5.46564 15.0631 5.52376 14.9168 5.52376H13.8135V6.62702C13.8135 6.77332 13.7554 6.91363 13.652 7.01708C13.5485 7.12053 13.4082 7.17865 13.2619 7.17865C13.1156 7.17865 12.9753 7.12053 12.8719 7.01708C12.7684 6.91363 12.7103 6.77332 12.7103 6.62702V5.52376H11.607C11.4607 5.52376 11.3204 5.46564 11.217 5.36219C11.1135 5.25874 11.0554 5.11844 11.0554 4.97214ZM18.2266 8.2819C18.2266 8.4282 18.1684 8.56851 18.065 8.67196C17.9615 8.77541 17.8212 8.83353 17.6749 8.83353H17.1233V9.38516C17.1233 9.53146 17.0652 9.67176 16.9617 9.77521C16.8583 9.87866 16.718 9.93678 16.5717 9.93678C16.4254 9.93678 16.2851 9.87866 16.1816 9.77521C16.0782 9.67176 16.0201 9.53146 16.0201 9.38516V8.83353H15.4684C15.3221 8.83353 15.1818 8.77541 15.0784 8.67196C14.9749 8.56851 14.9168 8.4282 14.9168 8.2819C14.9168 8.1356 14.9749 7.99529 15.0784 7.89184C15.1818 7.78839 15.3221 7.73027 15.4684 7.73027H16.0201V7.17865C16.0201 7.03234 16.0782 6.89204 16.1816 6.78859C16.2851 6.68514 16.4254 6.62702 16.5717 6.62702C16.718 6.62702 16.8583 6.68514 16.9617 6.78859C17.0652 6.89204 17.1233 7.03234 17.1233 7.17865V7.73027H17.6749C17.8212 7.73027 17.9615 7.78839 18.065 7.89184C18.1684 7.99529 18.2266 8.1356 18.2266 8.2819Z"
                          fill="#49546C"
                        />
                      </svg>
                    </span>{" "}
                    Unlimited Queries
                  </li>
                  <li>
                    <span className="billing-popup-access-icon">
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.30742 16.7403C7.2873 16.7403 7.26048 16.7537 7.24036 16.7537C5.93945 16.11 4.87995 15.0438 4.22949 13.7428C4.22949 13.7227 4.2429 13.6959 4.2429 13.6758C5.061 13.9172 5.90592 14.0982 6.74414 14.2391C6.89167 15.084 7.06602 15.9222 7.30742 16.7403Z"
                          fill="#49546C"
                        />
                        <path
                          d="M16.2236 13.7495C15.5598 15.084 14.4533 16.1636 13.1055 16.8141C13.3603 15.9624 13.5749 15.1041 13.7157 14.2391C14.5606 14.0982 15.3921 13.9172 16.2102 13.6758C16.2035 13.7026 16.2236 13.7294 16.2236 13.7495Z"
                          fill="#49546C"
                        />
                        <path
                          d="M16.2773 7.89056C15.4324 7.63574 14.5807 7.42787 13.7157 7.28034C13.5749 6.4153 13.367 5.55697 13.1055 4.71875C14.4936 5.38262 15.6134 6.50247 16.2773 7.89056Z"
                          fill="#49546C"
                        />
                        <path
                          d="M7.31029 4.78965C7.06888 5.60775 6.89453 6.43926 6.75371 7.28418C5.88867 7.41829 5.03034 7.63288 4.17871 7.8877C4.82917 6.53984 5.90879 5.4334 7.24323 4.76953C7.26335 4.76953 7.29017 4.78965 7.31029 4.78965Z"
                          fill="#49546C"
                        />
                        <path
                          d="M12.5683 7.14043C11.0126 6.96608 9.44342 6.96608 7.8877 7.14043C8.05534 6.22175 8.26992 5.30306 8.57168 4.4179C8.58509 4.36426 8.57839 4.32402 8.58509 4.27038C9.11484 4.14297 9.65801 4.0625 10.228 4.0625C10.7913 4.0625 11.3411 4.14297 11.8642 4.27038C11.8709 4.32402 11.8709 4.36426 11.8843 4.4179C12.1861 5.30977 12.4007 6.22175 12.5683 7.14043Z"
                          fill="#49546C"
                        />
                        <path
                          d="M6.59648 13.1064C5.67109 12.9387 4.75911 12.7242 3.87396 12.4224C3.82031 12.409 3.78008 12.4157 3.72643 12.409C3.59902 11.8792 3.51855 11.3361 3.51855 10.7661C3.51855 10.2028 3.59902 9.65293 3.72643 9.12988C3.78008 9.12318 3.82031 9.12318 3.87396 9.10977C4.76582 8.81471 5.67109 8.59342 6.59648 8.42578C6.42884 9.98151 6.42884 11.5507 6.59648 13.1064Z"
                          fill="#49546C"
                        />
                        <path
                          d="M16.9314 10.7661C16.9314 11.3361 16.851 11.8792 16.7236 12.409C16.6699 12.4157 16.6297 12.409 16.576 12.4224C15.6842 12.7174 14.7722 12.9387 13.8535 13.1064C14.0279 11.5507 14.0279 9.98151 13.8535 8.42578C14.7722 8.59342 15.6909 8.80801 16.576 9.10977C16.6297 9.12318 16.6699 9.12988 16.7236 9.12988C16.851 9.65964 16.9314 10.2028 16.9314 10.7661Z"
                          fill="#49546C"
                        />
                        <path
                          d="M12.5683 14.3945C12.4007 15.3199 12.1861 16.2319 11.8843 17.1171C11.8709 17.1707 11.8709 17.2109 11.8642 17.2646C11.3411 17.392 10.7913 17.4725 10.228 17.4725C9.65801 17.4725 9.11484 17.392 8.58509 17.2646C8.57839 17.2109 8.58509 17.1707 8.57168 17.1171C8.27663 16.2252 8.05534 15.3199 7.8877 14.3945C8.66556 14.4817 9.44342 14.5421 10.228 14.5421C11.0126 14.5421 11.7971 14.4817 12.5683 14.3945Z"
                          fill="#49546C"
                        />
                        <path
                          d="M12.7479 13.2918C11.0707 13.5034 9.37786 13.5034 7.7007 13.2918C7.48909 11.6146 7.48909 9.92181 7.7007 8.24464C9.37786 8.03304 11.0707 8.03304 12.7479 8.24464C12.9595 9.92181 12.9595 11.6146 12.7479 13.2918Z"
                          fill="#49546C"
                        />
                      </svg>
                    </span>{" "}
                    Unlimited Access to Current Affairs
                  </li>
                  <li>
                    <span className="billing-popup-access-icon">
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.9606 5.03125H4.49183C4.21531 5.03125 3.95012 5.1411 3.75459 5.33662C3.55907 5.53215 3.44922 5.79735 3.44922 6.07386V15.4574C3.44922 15.7339 3.55907 15.9991 3.75459 16.1946C3.95012 16.3902 4.21531 16.5 4.49183 16.5H15.9606C16.2371 16.5 16.5023 16.3902 16.6978 16.1946C16.8933 15.9991 17.0032 15.7339 17.0032 15.4574V6.07386C17.0032 5.79735 16.8933 5.53215 16.6978 5.33662C16.5023 5.1411 16.2371 5.03125 15.9606 5.03125ZM6.05575 8.41974C6.05575 8.558 6.00083 8.6906 5.90307 8.78836C5.8053 8.88613 5.67271 8.94105 5.53445 8.94105C5.39619 8.94105 5.26359 8.88613 5.16583 8.78836C5.06806 8.6906 5.01314 8.558 5.01314 8.41974V7.63778C5.01314 7.49952 5.06806 7.36693 5.16583 7.26916C5.26359 7.1714 5.39619 7.11648 5.53445 7.11648H10.2262C10.3645 7.11648 10.4971 7.1714 10.5948 7.26916C10.6926 7.36693 10.7475 7.49952 10.7475 7.63778V8.41974C10.7475 8.558 10.6926 8.6906 10.5948 8.78836C10.4971 8.88613 10.3645 8.94105 10.2262 8.94105C10.0879 8.94105 9.95535 8.88613 9.85759 8.78836C9.75982 8.6906 9.7049 8.558 9.7049 8.41974V8.15909H8.40163V11.2869H8.66229C8.80055 11.2869 8.93314 11.3419 9.03091 11.4396C9.12867 11.5374 9.18359 11.67 9.18359 11.8082C9.18359 11.9465 9.12867 12.0791 9.03091 12.1769C8.93314 12.2746 8.80055 12.3295 8.66229 12.3295H7.09837C6.96011 12.3295 6.82751 12.2746 6.72975 12.1769C6.63198 12.0791 6.57706 11.9465 6.57706 11.8082C6.57706 11.67 6.63198 11.5374 6.72975 11.4396C6.82751 11.3419 6.96011 11.2869 7.09837 11.2869H7.35902V8.15909H6.05575V8.41974ZM14.918 14.4148H7.09837C6.96011 14.4148 6.82751 14.3598 6.72975 14.2621C6.63198 14.1643 6.57706 14.0317 6.57706 13.8935C6.57706 13.7552 6.63198 13.6226 6.72975 13.5248C6.82751 13.4271 6.96011 13.3722 7.09837 13.3722H14.918C15.0562 13.3722 15.1888 13.4271 15.2866 13.5248C15.3844 13.6226 15.4393 13.7552 15.4393 13.8935C15.4393 14.0317 15.3844 14.1643 15.2866 14.2621C15.1888 14.3598 15.0562 14.4148 14.918 14.4148ZM14.918 12.3295H10.7475C10.6093 12.3295 10.4767 12.2746 10.3789 12.1769C10.2811 12.0791 10.2262 11.9465 10.2262 11.8082C10.2262 11.67 10.2811 11.5374 10.3789 11.4396C10.4767 11.3419 10.6093 11.2869 10.7475 11.2869H14.918C15.0562 11.2869 15.1888 11.3419 15.2866 11.4396C15.3844 11.5374 15.4393 11.67 15.4393 11.8082C15.4393 11.9465 15.3844 12.0791 15.2866 12.1769C15.1888 12.2746 15.0562 12.3295 14.918 12.3295ZM14.918 10.2443H11.7901C11.6519 10.2443 11.5193 10.1894 11.4215 10.0916C11.3237 9.99387 11.2688 9.86127 11.2688 9.72301C11.2688 9.58475 11.3237 9.45216 11.4215 9.35439C11.5193 9.25663 11.6519 9.2017 11.7901 9.2017H14.918C15.0562 9.2017 15.1888 9.25663 15.2866 9.35439C15.3844 9.45216 15.4393 9.58475 15.4393 9.72301C15.4393 9.86127 15.3844 9.99387 15.2866 10.0916C15.1888 10.1894 15.0562 10.2443 14.918 10.2443Z"
                          fill="#49546C"
                        />
                      </svg>
                    </span>{" "}
                    Full access to Study Mode
                  </li>
                  <li>
                    <span className="billing-popup-access-icon">
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.8516 3.26551H13.0188C12.6676 2.87233 12.2373 2.55774 11.7561 2.34235C11.275 2.12696 10.7537 2.01563 10.2266 2.01562C9.69938 2.01562 9.17815 2.12696 8.69698 2.34235C8.21581 2.55774 7.78555 2.87233 7.43438 3.26551H4.60156C4.27004 3.26551 3.9521 3.39721 3.71768 3.63163C3.48326 3.86605 3.35156 4.18399 3.35156 4.51551V17.6405C3.35156 17.972 3.48326 18.29 3.71768 18.5244C3.9521 18.7588 4.27004 18.8905 4.60156 18.8905H15.8516C16.1831 18.8905 16.501 18.7588 16.7354 18.5244C16.9699 18.29 17.1016 17.972 17.1016 17.6405V4.51551C17.1016 4.18399 16.9699 3.86605 16.7354 3.63163C16.501 3.39721 16.1831 3.26551 15.8516 3.26551ZM10.2266 3.26551C10.8896 3.26551 11.5255 3.5289 11.9943 3.99774C12.4632 4.46659 12.7266 5.10247 12.7266 5.76551H7.72656C7.72656 5.10247 7.98995 4.46659 8.4588 3.99774C8.92764 3.5289 9.56352 3.26551 10.2266 3.26551ZM12.7266 13.2655H7.72656C7.5608 13.2655 7.40183 13.1997 7.28462 13.0825C7.16741 12.9652 7.10156 12.8063 7.10156 12.6405C7.10156 12.4748 7.16741 12.3158 7.28462 12.1986C7.40183 12.0814 7.5608 12.0155 7.72656 12.0155H12.7266C12.8923 12.0155 13.0513 12.0814 13.1685 12.1986C13.2857 12.3158 13.3516 12.4748 13.3516 12.6405C13.3516 12.8063 13.2857 12.9652 13.1685 13.0825C13.0513 13.1997 12.8923 13.2655 12.7266 13.2655ZM12.7266 10.7655H7.72656C7.5608 10.7655 7.40183 10.6997 7.28462 10.5825C7.16741 10.4652 7.10156 10.3063 7.10156 10.1405C7.10156 9.97475 7.16741 9.81578 7.28462 9.69857C7.40183 9.58136 7.5608 9.51551 7.72656 9.51551H12.7266C12.8923 9.51551 13.0513 9.58136 13.1685 9.69857C13.2857 9.81578 13.3516 9.97475 13.3516 10.1405C13.3516 10.3063 13.2857 10.4652 13.1685 10.5825C13.0513 10.6997 12.8923 10.7655 12.7266 10.7655Z"
                          fill="#49546C"
                        />
                      </svg>
                    </span>{" "}
                    Unlimited Access to Tests
                  </li>
                  <li>
                    <span className="billing-popup-access-icon">
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.5 3.5H5.5C4.39543 3.5 3.5 4.39543 3.5 5.5V16.5C3.5 17.6046 4.39543 18.5 5.5 18.5H15.5C16.6046 18.5 17.5 17.6046 17.5 16.5V5.5C17.5 4.39543 16.6046 3.5 15.5 3.5Z"
                          stroke="#49546C"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M7 7.5H14"
                          stroke="#49546C"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M7 11H14"
                          stroke="#49546C"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                        <path
                          d="M7 14.5H11.5"
                          stroke="#49546C"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                        />
                      </svg>
                    </span>{" "}
                    Full access to My Notes
                  </li>
                </ul>
                <button
                  className="billing-popup-continue"
                  onClick={() => {
                    navigate("/Price");
                  }}
                >
                  Continue My Journey
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Biling;
